// extracted by mini-css-extract-plugin
export default {"sidebar":"ProfileSidebar_sidebar__Spogx","menuItem":"ProfileSidebar_menuItem__cx4CG","active":"ProfileSidebar_active__u7xbS"};